import { useEffect, useState } from 'react';
import { flattenContentfulObject } from '../services/contentful';
import { parseContributor } from './contributors';
// ---------- TYPES ----------
export var ArticleType;
(function (ArticleType) {
    ArticleType["Podcast"] = "podcast";
    ArticleType["Article"] = "article";
    ArticleType["Video"] = "video";
    ArticleType["Interactive"] = "interactive";
})(ArticleType || (ArticleType = {}));
// ---------- FUNCTIONS ----------
const parseArticle = (data) => {
    if (!data || !data.fields) {
        return;
    }
    return {
        ...data.fields,
        id: data.sys.id,
        date: data.fields.articleDate,
        credits: data.fields.credits
            ? data.fields.credits
                .map((c) => parseContributor(c))
                .filter((c) => c !== undefined)
            : [],
        featuredImage: data.fields.featuredImage
            ? flattenContentfulObject(data.fields.featuredImage)
            : undefined
    };
};
export const getArticles = async (contentfulClient) => {
    try {
        const items = [];
        let total = 1000;
        const pageSize = 50;
        while (items.length < total) {
            const response = await contentfulClient.getEntries({
                content_type: 'article',
                include: 4,
                limit: pageSize,
                skip: items.length,
                order: '-fields.articleDate'
            });
            items.push(...response.items);
            total = response.total;
        }
        return items
            .map((a) => parseArticle(a))
            .filter((a) => a !== undefined);
    }
    catch (error) {
        const axiosError = error;
        console.log('ERROR: getArticles', axiosError.message, axiosError.code);
    }
    return [];
};
export const getArticleBySlug = async (contentfulClient, slug) => {
    const response = await contentfulClient.getEntries({
        content_type: 'article',
        include: 4,
        limit: 1,
        'fields.slug[in]': slug
    });
    const items = response.items
        .map((a) => parseArticle(a))
        .filter((a) => a !== undefined);
    return items.length > 0 ? items[0] : undefined;
};
export const useArticle = (contentfulClient, slug, _article, isFocused = true) => {
    const [article, setArticle] = useState(_article);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (!slug) {
            return;
        }
        if (!article) {
            setLoading(true);
            getArticleBySlug(contentfulClient, slug).then((a) => {
                setArticle(a);
                setLoading(false);
            });
        }
    }, [isFocused, slug]);
    return { article, loading };
};
export const getPreviewArticle = async (contentfulPreviewClient, id) => {
    const response = await contentfulPreviewClient.getEntries({
        content_type: 'article',
        'sys.id': id,
        include: 8
    });
    const articles = response.items.map((a) => parseArticle(a));
    return articles.length > 0 ? articles[0] : undefined;
};
//# sourceMappingURL=articles.js.map